/* Collection Page — filter drawer, sort, load-more, FAQ accordion, add-to-cart.
   Structure: sections/custom-collection-page.liquid. Styles: assets/collection-page.css.
   Guarded to no-op wherever the corresponding markup isn't present. */

(function () {
  var faqItems = document.querySelectorAll('.coll-page .faq-item');
  faqItems.forEach(function (item) {
    var q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', function () {
      var willOpen = !item.classList.contains('open');
      item.classList.toggle('open', willOpen);
      q.setAttribute('aria-expanded', willOpen);
    });
  });
})();

(function () {
  var grid = document.getElementById('collGrid');
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
  var emptyEl = document.getElementById('collEmpty');
  var sortSelect = document.getElementById('collSort');
  var filterCountBadge = document.getElementById('collFilterCount');
  var drawer = document.getElementById('collDrawer');

  var state = { collections: [], types: [], prices: [] };

  function loadedCards() {
    return cards.filter(function (c) { return !c.classList.contains('not-loaded'); });
  }

  function priceInRange(price, range) {
    var parts = range.split('-');
    var min = parseInt(parts[0], 10), max = parseInt(parts[1], 10);
    return price >= min && price <= max;
  }

  function applyFilters() {
    var visible = 0;
    loadedCards().forEach(function (card) {
      var type = card.getAttribute('data-type');
      var collections = (card.getAttribute('data-collections') || '').split(' ').filter(Boolean);
      var price = parseFloat(card.getAttribute('data-price'));

      var matchesType = state.types.length === 0 || state.types.indexOf(type) !== -1;
      var matchesCollection = state.collections.length === 0 || state.collections.some(function (c) { return collections.indexOf(c) !== -1; });
      var matchesPrice = state.prices.length === 0 || state.prices.some(function (r) { return priceInRange(price, r); });

      var show = matchesType && matchesCollection && matchesPrice;
      card.classList.toggle('is-hidden', !show);
      if (show) visible++;
    });

    if (emptyEl) emptyEl.classList.toggle('show', visible === 0);

    if (filterCountBadge) {
      var activeFilterCount = state.collections.length + state.types.length + state.prices.length;
      filterCountBadge.textContent = activeFilterCount;
      filterCountBadge.classList.toggle('show', activeFilterCount > 0);
    }
  }

  function applySort() {
    if (!sortSelect) return;
    var visibleCards = loadedCards().filter(function (c) { return !c.classList.contains('is-hidden'); });
    var mode = sortSelect.value;
    var sorted = visibleCards.slice();

    if (mode === 'price-asc') sorted.sort(function (a, b) { return a.getAttribute('data-price') - b.getAttribute('data-price'); });
    else if (mode === 'price-desc') sorted.sort(function (a, b) { return b.getAttribute('data-price') - a.getAttribute('data-price'); });
    else if (mode === 'new') sorted.sort(function (a, b) { return b.getAttribute('data-new') - a.getAttribute('data-new'); });
    else if (mode === 'best') sorted.sort(function (a, b) { return b.getAttribute('data-best') - a.getAttribute('data-best'); });
    /* 'featured' = original DOM order, no-op */
    sorted.forEach(function (c) { grid.appendChild(c); });
  }

  if (sortSelect) sortSelect.addEventListener('change', applySort);

  /* Filter drawer */
  var overlay = document.getElementById('collDrawerOverlay');
  var actions = document.getElementById('collDrawerActions');
  var filterBtn = document.getElementById('collFilterBtn');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    if (actions) actions.classList.add('open');
    if (filterBtn) filterBtn.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    if (actions) actions.classList.remove('open');
    if (filterBtn) filterBtn.setAttribute('aria-expanded', 'false');
  }
  if (filterBtn) filterBtn.addEventListener('click', openDrawer);
  var drawerClose = document.getElementById('collDrawerClose');
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  var drawerApply = document.getElementById('collDrawerApply');
  if (drawerApply && drawer) {
    drawerApply.addEventListener('click', function () {
      state.collections = Array.prototype.slice.call(drawer.querySelectorAll('input[name="collection"]:checked')).map(function (i) { return i.value; });
      state.types = Array.prototype.slice.call(drawer.querySelectorAll('input[name="type"]:checked')).map(function (i) { return i.value; });
      state.prices = Array.prototype.slice.call(drawer.querySelectorAll('input[name="price"]:checked')).map(function (i) { return i.value; });
      applyFilters();
      applySort();
      closeDrawer();
    });
  }

  var drawerClear = document.getElementById('collDrawerClear');
  if (drawerClear && drawer) {
    drawerClear.addEventListener('click', function () {
      drawer.querySelectorAll('input[type="checkbox"]').forEach(function (i) { i.checked = false; });
      state.collections = []; state.types = []; state.prices = [];
      applyFilters();
      applySort();
    });
  }

  /* Load More — reveals the next batch; disables once every product is loaded */
  var loadMoreBtn = document.getElementById('collLoadMoreBtn');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      var batchSize = parseInt(loadMoreBtn.getAttribute('data-batch-size'), 10) || 12;
      var hidden = cards.filter(function (c) { return c.classList.contains('not-loaded'); }).slice(0, batchSize);
      if (hidden.length === 0) return;
      hidden.forEach(function (c) { c.classList.remove('not-loaded'); });
      applyFilters();
      applySort();
      if (cards.filter(function (c) { return c.classList.contains('not-loaded'); }).length === 0) {
        loadMoreBtn.textContent = loadMoreBtn.getAttribute('data-done-label') || "You've seen the full collection";
        loadMoreBtn.disabled = true;
      }
    });
  }

  applyFilters();
})();

/* Add to Cart — real /cart/add.js call, then let the store's cart drawer
   (UpCart) auto-detect and open itself. No redirect and no manual cart
   re-fetch here, matching assets/ceremony-page.js's ATC handler — doing
   either made a second cart appear / made adding feel slow. */
(function () {
  document.querySelectorAll('.coll-page .p-atc-btn[data-variant-id]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      var originalLabel = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          btn.disabled = false;
          btn.textContent = 'Added ✓';
          setTimeout(function () {
            btn.textContent = originalLabel;
          }, 2500);
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Try again';
          setTimeout(function () {
            btn.textContent = originalLabel;
          }, 2000);
        });
    });
  });
})();
